export default __webpack_public_path__ + "images/Profile-Image.svg";